import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext.tsx";
import { NAV_SECTIONS, SECTION_IDS } from "../constants/sections.ts";
import { useScrollSpy } from "../hooks/useScrollSpy.ts";
import { scrollToSection } from "../utils/scrollToSection.ts";

function Header({ headerClass = null, isLandingPage = false }) {
  const [menu, setMenu] = useState(false);
  const [show, setShow] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const { userEmail, logout, isAuthenticated } = useAuth();
  const dropdownRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const isDashboardPage =
    location.pathname.startsWith("/dashboard") ||
    location.pathname.startsWith("/profile");

  const onLanding = isLandingPage || location.pathname === "/";
  const sectionIds = useMemo(() => NAV_SECTIONS.map((item) => item.id), []);
  const rawActiveSection = useScrollSpy(onLanding ? sectionIds : []);
  const activeSection = rawActiveSection || (onLanding ? SECTION_IDS.comoFunciona : null);

  const handleSectionNav = (sectionId) => {
    setMenu(false);
    if (onLanding) {
      scrollToSection(sectionId);
      return;
    }
    navigate("/");
    window.setTimeout(() => scrollToSection(sectionId), 200);
  };

  const handleLogoClick = (event) => {
    if (!onLanding) return;
    event.preventDefault();
    scrollToSection(SECTION_IDS.inicio);
  };

  const navLinkStyle = (sectionId) => {
    const isActive = activeSection === sectionId;
    return {
      fontSize: 15,
      color: isActive ? "#0d1f1a" : "rgba(255,255,255,0.85)",
      fontWeight: isActive ? 600 : 400,
      background: isActive ? "#00D094" : "transparent",
      borderRadius: 20,
      padding: isActive ? "6px 18px" : "6px 18px",
      border: "none",
      transition: "all 0.2s ease",
    };
  };

  const changeImage = useCallback((themeMode = "light") => {
    if (typeof document === "undefined") return;
    const icon = document.querySelector("#btnSwitch img");
    if (icon) {
      icon.src =
        themeMode === "dark"
          ? "images/icon/sun.svg"
          : "images/icon/moon.svg";
    }
  }, []);

  const updateThemeColor = useCallback(
    (themeMode = "light") => {
      if (typeof document === "undefined") return;
      document.documentElement.setAttribute("data-bs-theme", themeMode);
      localStorage.setItem("theme", themeMode);
      changeImage(themeMode);
    },
    [changeImage]
  );
  // console.log("o que tem no local storage do tema?", localStorage);
  // useEffect(() => {
  //   const token = Cookies.get("token");
  //   const email = localStorage.getItem("userEmail");
  //   setUserEmail(token && email ? email : null);
  // }, [location.pathname]);

  useEffect(() => {
    // console.log("👤 Header - Auth State atualizado:", {
    //   isAuthenticated,
    //   userEmail,
    //   pathname: location.pathname
    // });
  }, [isAuthenticated, userEmail, location.pathname]);

  // const getInitial = () => userEmail?.charAt(0).toUpperCase() || "";

  // const handleLogout = () => {
  //   Cookies.remove("token");
  //   localStorage.removeItem("userEmail");
  //   setUserEmail(null);
  //   navigate("/login");
  // };

  // const handleLogout = () => {
  //   Cookies.remove("token");
  //   localStorage.removeItem("token"); // ← Adicionar esta linha
  //   localStorage.removeItem("userEmail");
  //   setUserEmail(null);
  //   navigate("/login");
  // };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShow(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    updateThemeColor("dark");
  }, [updateThemeColor]);


  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout(); // Usa a função do contexto
  };

  const getInitial = () => userEmail?.charAt(0).toUpperCase() || "";

  // console.log("👤 Header - Estado:", { userEmail, isAuthenticated });


  const toggleMenu = () => setMenu(!menu);

  if (isDashboardPage) {
    return (
      <header className="landing-header-shell fixed inset-x-0 top-0 z-50">
        <div className="relative mx-auto flex h-[72px] max-w-[1200px] items-center justify-between px-4 md:px-6">
          <Link
            to="/"
            className="landing-header-brand flex shrink-0 items-center gap-2.5 rounded-full px-2 py-1.5"
          >
            <img
              src="/BB-icon.png"
              alt=""
              className="h-10 w-auto object-contain"
            />
            <span className="hidden text-[16px] font-bold tracking-tight text-white sm:inline">
              Binary<span className="text-[#29d585]">Bucks</span>
            </span>
          </Link>

          <nav className="landing-header-nav absolute left-1/2 top-1/2 hidden -translate-x-1/2 -translate-y-1/2 items-center gap-1 rounded-full p-1.5 backdrop-blur-md md:flex">
            <button
              type="button"
              className="landing-header-nav-active rounded-full px-5 py-2 text-[13px] font-bold text-[#021008]"
              onClick={() => navigate("/dashboard")}
            >
              Sinais
            </button>
            <button
              type="button"
              className="rounded-full px-5 py-2 text-[13px] font-bold text-white/[0.78] transition-colors hover:bg-white/[0.045] hover:text-white"
              onClick={() => navigate("/profile")}
            >
              Perfil
            </button>
          </nav>

          <div className="flex shrink-0 items-center gap-3">
            {userEmail ? (
              <div ref={dropdownRef} className="relative">
                <button
                  type="button"
                  onClick={() => setShow((prev) => !prev)}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-[#13d18d] text-sm font-bold text-[#03120e] shadow-[0_12px_28px_rgba(2,230,193,0.16)]"
                  title={userEmail}
                >
                  {getInitial()}
                </button>

                {show && (
                  <div className="absolute right-0 top-full z-50 mt-3 min-w-[170px] overflow-hidden rounded-xl border border-[#1f3a32]/80 bg-[#061a14]/95 py-1.5 shadow-[0_18px_48px_rgba(0,0,0,0.34)] backdrop-blur-md">
                    <button
                      type="button"
                      className="block w-full px-4 py-2.5 text-left text-sm font-medium text-white/78 transition-colors hover:bg-white/[0.045] hover:text-white"
                      onClick={() => navigate("/dashboard")}
                    >
                      Dashboard
                    </button>
                    <button
                      type="button"
                      className="block w-full px-4 py-2.5 text-left text-sm font-medium text-white/78 transition-colors hover:bg-white/[0.045] hover:text-white"
                      onClick={() => navigate("/profile")}
                    >
                      Perfil
                    </button>
                    <button
                      type="button"
                      className="block w-full px-4 py-2.5 text-left text-sm font-medium text-red-300 transition-colors hover:bg-red-500/10 hover:text-red-200"
                      onClick={handleLogout}
                    >
                      Sair
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <>
                <Link
                  to="/login"
                  className="hidden rounded-full px-3 py-2 text-[13px] font-bold text-white/64 transition-colors hover:bg-white/[0.045] hover:text-white sm:inline"
                >
                  Entrar
                </Link>
                <Link
                  to="/register"
                  className="landing-header-cta rounded-full px-4 py-2 text-[13px] font-bold"
                >
                  Começar Agora
                </Link>
              </>
            )}

            <button
              type="button"
              className="rounded-lg p-2 text-white/64 transition-colors hover:bg-white/[0.045] hover:text-white md:hidden"
              onClick={toggleMenu}
              aria-label={menu ? "Fechar menu" : "Abrir menu"}
            >
              <span className="block h-0.5 w-5 bg-current"></span>
              <span className="mt-1.5 block h-0.5 w-5 bg-current"></span>
              <span className="mt-1.5 block h-0.5 w-5 bg-current"></span>
            </button>
          </div>
        </div>

        {menu && (
          <div className="border-t border-[#1f3a32]/60 bg-[#03110c]/95 px-4 pb-5 pt-3 backdrop-blur-md md:hidden">
            <nav className="flex flex-col gap-1">
              <button
                type="button"
                className="rounded-lg bg-[#13d18d] px-4 py-2.5 text-left text-sm font-bold text-[#03120e]"
                onClick={() => {
                  setMenu(false);
                  navigate("/dashboard");
                }}
              >
                Sinais
              </button>
              <button
                type="button"
                className="rounded-lg px-4 py-2.5 text-left text-sm font-bold text-white/78 hover:bg-white/[0.045]"
                onClick={() => {
                  setMenu(false);
                  navigate("/profile");
                }}
              >
                Perfil
              </button>
            </nav>
          </div>
        )}
      </header>
    );
  }

  return (
    <header
      style={{ top: 0, zIndex: 1000 }}
      className={
        isDashboardPage || onLanding
          ? "header-section header-section--style2 header-fixed fadeInUp"
          : `${headerClass || "bg-color-3"}`
      }
    >
      <div className="header-bottom header-section header-fixed">
        <div className="container">
          <div className="header-wrapper">
            {/* LOGO */}
            <div className="logo">
              <Link to="/" onClick={handleLogoClick}>
                <img
                  className="dark"
                  width={42}
                  src="/BB-icon.png"
                  alt="Binary Bucks"
                  style={{ height: 42, width: "auto", objectFit: "contain" }}
                />
              </Link>
            </div>

            {/* MENU DESKTOP */}
            <div className="menu-area d-none d-lg-block">
              {/* <ul className={`menu menu--style1 ${menu ? "active" : ""}`}> */}
              <ul className={`menu menu--style1 ${menu ? "active" : ""} ${isDashboardPage ? 'no-before' : ''}`}>
                {!isDashboardPage && (
                  <>
                    {NAV_SECTIONS.map(({ id, label }) => (
                      <li key={id}>
                        <button
                          type="button"
                          onClick={() => handleSectionNav(id)}
                          style={{
                            ...navLinkStyle(id),
                            cursor: "pointer",
                          }}
                        >
                          {label}
                        </button>
                      </li>
                    ))}
                  </>
                )}
              </ul>
            </div>

            {/* AÇÕES DO HEADER */}
            <div className="header-action d-flex align-items-center">
              {userEmail ? (
                <div
                  ref={dropdownRef}
                  className="d-flex align-items-center gap-3 position-relative"
                >
                  {/* Avatar do usuário */}
                  <div
                    onClick={() => setShow((prev) => !prev)}
                    style={{
                      width: 45,
                      height: 45,
                      borderRadius: "50%",
                      backgroundColor: "#00D094",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "bold",
                      cursor: "pointer",
                      boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                    }}
                    title={userEmail}
                  >
                    {getInitial()}
                  </div>

                  {/* Dropdown */}
                  {show && (
                    <div
                      style={{
                        position: "absolute",
                        top: "120%",
                        right: 0,
                        background: "rgba(17, 25, 40, 0.95)",
                        border: "1px solid rgba(255,255,255,0.1)",
                        borderRadius: "0.75rem",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
                        zIndex: 999,
                        minWidth: 160,
                        backdropFilter: "blur(12px)",
                        overflow: "hidden",
                      }}
                    >
                      <ul
                        style={{
                          listStyle: "none",
                          margin: 0,
                          padding: "6px 0",
                        }}
                      >
                        {location.pathname !== "/dashboard" && (
                          <li
                            style={{
                              padding: "10px 16px",
                              cursor: "pointer",
                              color:
                                hoveredItem === "home"
                                  ? "#fff"
                                  : "rgba(255,255,255,0.8)",
                              background:
                                hoveredItem === "home"
                                  ? "rgba(59,130,246,0.3)"
                                  : "transparent",
                              transition: "0.3s",
                            }}
                            onClick={() => navigate("/dashboard")}
                            onMouseEnter={() => setHoveredItem("home")}
                            onMouseLeave={() => setHoveredItem(null)}
                          >
                            Dashboard
                          </li>
                        )}

                        <li
                          style={{
                            padding: "10px 16px",
                            cursor: "pointer",
                            color:
                              hoveredItem === "profile"
                                ? "#fff"
                                : "rgba(255,255,255,0.8)",
                            background:
                              hoveredItem === "profile"
                                ? "rgba(59,130,246,0.3)"
                                : "transparent",
                            transition: "0.3s",
                          }}
                          onClick={() => navigate("/profile")}
                          onMouseEnter={() => setHoveredItem("profile")}
                          onMouseLeave={() => setHoveredItem(null)}
                        >
                          Profile
                        </li>

                        <li
                          style={{
                            padding: "10px 16px",
                            cursor: "pointer",
                            color:
                              hoveredItem === "logout"
                                ? "#fff"
                                : "rgba(255,255,255,0.8)",
                            background:
                              hoveredItem === "logout"
                                ? "rgba(239,68,68,0.3)"
                                : "transparent",
                            transition: "0.3s",
                          }}
                          onClick={handleLogout}
                          onMouseEnter={() => setHoveredItem("logout")}
                          onMouseLeave={() => setHoveredItem(null)}
                        >
                          Logout
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              ) : (
                <div className="d-none d-lg-flex align-items-center gap-3">
                  <Link
                    to="/login"
                    style={{
                      fontSize: 15,
                      color: "rgba(255,255,255,0.85)",
                      textDecoration: "none",
                      fontWeight: 400,
                      transition: "color 0.2s",
                    }}
                  >
                    Entrar
                  </Link>
                  <Link
                    to="/register"
                    style={{
                      fontSize: 15,
                      fontWeight: 600,
                      color: "#0d1f1a",
                      background: "#00D094",
                      padding: "9px 22px",
                      borderRadius: 22,
                      textDecoration: "none",
                      boxShadow: "0 0 16px rgba(0,208,148,0.35)",
                      whiteSpace: "nowrap",
                      transition: "all 0.2s ease",
                    }}
                  >
                    Começar Agora →
                  </Link>
                </div>
              )}

              {/* Botão Mobile */}
              <div
                className={`header-bar d-lg-none header-bar--style1 ${menu ? "active" : ""
                  }`}
                onClick={toggleMenu}
              >
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>

          {/* MENU MOBILE */}
          {menu && (
            <div className="mobile-menu d-lg-none mt-3">
              <ul className="menu">
                {!isDashboardPage && (
                  <>
                    {NAV_SECTIONS.map(({ id, label }) => (
                      <li key={id}>
                        <button
                          type="button"
                          onClick={() => handleSectionNav(id)}
                          style={{
                            fontSize: 15,
                            background: "none",
                            border: "none",
                            color:
                              activeSection === id ? "#00D094" : "rgba(255,255,255,0.85)",
                            fontWeight: activeSection === id ? 600 : 400,
                            width: "100%",
                            textAlign: "left",
                            padding: "8px 0",
                            cursor: "pointer",
                          }}
                        >
                          {label}
                        </button>
                      </li>
                    ))}
                  </>
                )}
                {userEmail ? (
                  <li>
                    <button
                      onClick={handleLogout}
                      className="trk-btn trk-btn--outline w-100"
                      type="button"
                      style={{ width: "100%" }}
                    >
                      Logout
                    </button>
                  </li>
                ) : (
                  <>
                    <li>
                      <Link
                        to="/login"
                        style={{
                          fontSize: 13,
                          textDecoration: "none",
                          display: "block",
                          textAlign: "center",
                        }}
                        className="trk-btn trk-btn--outline"
                      >
                        Login
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/register"
                        className="trk-btn trk-btn--border trk-btn--secondary2 d-block text-center"
                      >
                        Sign up
                      </Link>
                    </li>
                  </>
                )}
              </ul>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
